import { vnTemplate } from '@valnet/vnKnockoutJsTemplates/vnTemplate';
import { filterDropdown_template } from '@valnet/vnKnockoutJsTemplates/filterDropdown_template';
import { listPagePagination_template as pagination_template } from '~/components/templates/listPagePagination_template';
import { resultsInfo_template } from '@valnet/vnKnockoutJsTemplates/resultsInfo_template';
import { filterSimple_template } from '@valnet/vnKnockoutJsTemplates/filterSimple_template';
import { infoButton_template } from '@valnet/vnKnockoutJsTemplates/infoButton_template';
import { autoRefresh_template } from '@valnet/vnKnockoutJsTemplates/autoRefresh_template';
import { filterSingleGroupSelector_template } from '~/components/templates/filterSingleGroupSelector_template';
import { filterPreset_template } from '@valnet/vnKnockoutJsTemplates/filterPreset_template';
import { multipleSelector_template } from '@valnet/vnKnockoutJsTemplates/multipleSelector_template';
import { filterMultipleAutoComplete_template } from '~/components/templates/filterMultipleAutoComplete_template';
import { html, LpButton, LpFilterBar, LpIcon, LpPageHeader, raw } from '~/design-system';
import { renderTasksTable } from '~/components/tasks/tasks-table';
function getTaskStatusOptionVariant(value) {
    const normalized = String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/[_\s]+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
    if (['in-progress', 'progress', 'running'].includes(normalized)) {
        return 'in-progress';
    }
    if (['done', 'completed', 'success'].includes(normalized)) {
        return 'done';
    }
    if (['error', 'failed', 'failure'].includes(normalized)) {
        return 'error';
    }
    if (['pending', 'queued', 'waiting'].includes(normalized)) {
        return 'pending';
    }
    return 'default';
}
function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
export class tasksList_template extends vnTemplate {
    //
    // implementation of base class [vnTemplate]
    getTemplateHtml() {
        return /* html */ `
                ${LpPageHeader({
            title: 'Tasks',
            description: 'Review scheduled tasks, execution status, and rescheduling activity.',
            icon: 'list-checks',
            controls: LpFilterBar({
                controls: html `
                            ${raw(this.renderFilterCell(this.filterPreset.getHtmlBuild(), "filter-preset", "bookmark-simple"))}
                            ${raw(this.renderFilterCell(this.brandFilter.getHtmlBuild(), "list-page-filter-cell--group-selector", "tag"))}

                            <!-- ko if: hasPipelineFilter -->
                            ${raw(this.renderFilterCell(this.pipelineFilter.getHtmlBuild(), "list-page-filter-cell--group-selector", "git-branch"))}
                            <!-- /ko -->

                            ${raw(this.renderFilterCell(this.executerAutocomplete.getHtmlBuild(), "list-page-filter-cell--autocomplete", "user"))}
                            ${raw(this.renderFilterCell(this.operationFilter.getHtmlBuild(), "list-page-filter-cell--group-selector", "gear-six"))}

                            <!-- ko if: hasTagFilter -->
                            ${raw(this.renderFilterCell(this.filterTag.getHtmlBuild(), "list-page-filter-cell--autocomplete", "tag"))}
                            <!-- /ko -->

                            ${raw(this.renderFilterCell(this.statusFilter.getHtmlBuild(), "list-page-filter-cell--status", "circle-half"))}

                            <!-- ko if: permissions()['tasklist_manage'] && permissions()['tasklist_manage'].update == true -->
                            ${raw(this.renderFilterCell(`${this.updateStatuses.getHtmlBuild()}
                                ${LpButton({
                    label: html `<span data-bind="text: (selectedCount() === 0) ? 'Apply' : 'Apply To ' + selectedCount() + ' Selected Tasks'"></span>`,
                    prefixIcon: 'check',
                    size: 'base',
                    variant: 'primary',
                    attributes: {
                        "data-bind": "css: { 'is-disable': selectedCount() === 0}, event: {click: onClickUpdate}",
                    },
                })}`, "list-page-filter-cell--bulk", "check-circle"))}
                            <!-- /ko -->
                        `,
            }),
        })}

                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                        <div id="selected-tags"></div>
                        <div id="selected-task_statuses"></div>
                        <div id="selected-executers"></div>
                    </div>
                </div>

                <div class="list-page-module tasks-module lp-layer-card" data-lp-component="LayerCard">
                    <div class="data-module__header list-page-module__header lp-layer-card_secondary" data-lp-layer-card-section="secondary">
                        <div class="list-page-module__search">
                            ${(this.simpleFilter.getHtmlBuild())}
                        </div>
                        <div class="list-page-module__actions">
                            ${(this.autoRefresh.getHtmlBuild())}
                            ${LpButton({
            label: 'Refresh',
            prefixIcon: 'arrows-clockwise',
            size: 'base',
            variant: 'refresh',
            attributes: {
                'data-bind': 'click: onClickRefresh, disable: isLoading() === 1',
            },
        })}
                            ${LpButton({
            label: html `<span data-bind="text: listMoreInfo() ? 'Less' : 'Expand'"></span>`,
            prefixIcon: 'arrows-out-simple',
            size: 'sm',
            variant: 'secondary',
            attributes: {
                'data-bind': 'click: toggleListMoreInfo',
            },
        })}
                            <!-- ko if: permissions()['tasklist_manage'] && permissions()['tasklist_manage'].write == true -->
                            ${LpButton({
            label: 'Add task',
            prefixIcon: 'plus',
            size: 'base',
            variant: 'primary',
            attributes: {
                'data-bind': 'click: onClickAdd',
            },
        })}
                            <!-- /ko -->
                        </div>
                    </div>

                    <div class="data-module__body list-page-module__body lp-layer-card_primary" data-lp-layer-card-section="primary" data-padding="none" id="list-results">
                        ${renderTasksTable()}
                    </div>
                    <div class="data-module__footer list-page-module__footer">
                        <div class="list-page-module__toolbar">
                            <div class="list-page-module__meta">
                                ${(this.resultsInfo.getHtmlBuild())}
                            </div>
                            <div class="list-page-module__pagination">
                                ${(this.pagination.getHtmlBuild())}
                            </div>
                        </div>
                    </div>
                </div>



                <div data-bind="css: { 'is-visible': taskDeleteConfirmationVisible }"  class="w-lightbox dark-theme">

                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                 <strong class="form-title">Delete Task</strong>
                                 ${LpButton({
            ariaLabel: 'Close',
            prefixIcon: 'x',
            size: 'sm',
            shape: 'square',
            variant: 'ghost',
            className: 'close-button',
            attributes: {
                'data-bind': 'event: { click: onClickDeleteDialogHide }',
            },
        })}
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                        <!-- ko if: taskToDelete().status.id == 1 -->
                                            <p class="form-text">This task is currently in-progress,  deleting it may have unexpected results</p>
                                        <!-- /ko -->
                                        <p class="form-text">Are you sure you want to delete this task</p>
                                </div>
                            </div>
                            <div class="form-footer">
                                <button data-bind="event: { click: onClickDeleteDialogHide }" class="btn light half" type="button">Cancel</button>
                                <button data-bind="event: { click: onClickDeleteConfirm }" class="btn highlight half" type="button">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div data-bind="css: { 'is-visible': taskUpdateConfirmationVisible }"  class="w-lightbox dark-theme">

                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                 <strong class="form-title">Update Task</strong>
                                 ${LpButton({
            ariaLabel: 'Close',
            prefixIcon: 'x',
            size: 'sm',
            shape: 'square',
            variant: 'ghost',
            className: 'close-button',
            attributes: {
                'data-bind': 'event: { click: onClickUpdateDialogHide }',
            },
        })}
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                        <p class="form-text">Are you sure you want to update task(s)</p>
                                </div>
                            </div>
                            <div class="form-footer">
                                <button data-bind="event: { click: onClickUpdateDialogHide }" class="btn light half" type="button">Cancel</button>
                                <button data-bind="event: { click: onClickUpdateConfirm }" class="btn highlight half" type="button">Update</button>
                            </div>
                        </div>

                    </div>
                </div>



                <div class="w-timeline" id="timeline" data-bind="css: {'is-open' : taskToReschedule() != null}">
                    <div class="w-timeline-btn">
                        <button class="btn alert" type="button" data-bind="event: { click: onClickCancelReschedule}">cancel</button>
                        <button class="btn" type="button" data-bind="disable: taskToRescheduleIsConflicting() == true, event: { click: onClickSaveReschedule}">save</button>
                    </div>

                    <div class="timeline-option" data-bind="css: {'is-open': manualTimeRescheduleIsOpen() == true}">

                        <!-- <input type="time" id="appt" name="appt" step="1" data-bind="value: taskToRescheduleTargetTime, event: { change: onChangeSetRescheduleTime}"> -->
                        <label for="" class="form-label">Set time<br>Manually</label>
                        <div class="w-time-picker icon i-reschedule">
                            <input type="number" min="0" max="23" step="1" id="hour" name="hour" data-bind="value: taskToRescheduleTargetTimeHour, event: { change: onChangeSetRescheduleTime}">
                            <span>:</span>
                            <input type="number" min="0" max="59" step="1" id="minute" name="minute" data-bind="value: taskToRescheduleTargetTimeMinute, event: { change: onChangeSetRescheduleTime}">
                            <span>:</span>
                            <input type="number" min="0" max="59" step="1" id="second" name="second" data-bind="value: taskToRescheduleTargetTimeSecond, event: { change: onChangeSetRescheduleTime}">

                        </div>
                        <button class="option-btn icon i-dropdown-simple" type="button" data-bind="event: { click: onClickToggleManualTimeRescheduleIsOpen}"></button>

                    </div>

                    <div class="timeline-list" data-bind="foreach: timeline">

                        <!-- ko if: type == 'date' -->
                        <time class="timeline-day" data-bind="text: date"></time>
                        <!-- /ko -->

                        <!-- ko if: type == 'slot' -->
                        <button class="timeline-btn" data-bind="event: { click: $parent.onClickUpdateRescheduledSelection }"></button>
                        <!-- /ko -->

                        <!-- ko if: type == 'slotWithTargetFlag' -->
                        <div class="timeline-btn is-selected">
                            <div class="timeline-marker" data-bind="event: { click: $parent.onClickUpdateRescheduledSelection }">
                                <span class="icon i-task-group"></span>
                                <span class="icon i-arrow-right"></span>
                                <span class="icon i-reschedule"></span>
                                <time data-bind="text: time"></time>
                            </div>
                        </div>
                        <!-- /ko -->

                        <!-- ko if: type == 'targetFlag' -->
                       <div class="timeline-btn is-not-selected">
                            <div class="timeline-marker" data-bind="event: { click: $parent.onClickUpdateRescheduledSelection }">
                                <span class="icon i-task-group"></span>
                                <span class="icon i-arrow-right"></span>
                                <span class="icon i-reschedule"></span>
                                <time data-bind="text: time"></time>
                            </div>
                        </div>
                        <!-- /ko -->

                        <!-- ko if: type == 'block' -->
                        <div class="timeline-item" data-bind="css: {'is-selected': (source == true && $parent.taskToRescheduleTargetTime() == time && $parent.taskToRescheduleTargetDate() == date), 'is-moved': (source == true && ( $parent.taskToRescheduleTargetTime() != time || $parent.taskToRescheduleTargetDate() != date))}">
                            <!--
                            <div class="timeline-details">
                                <div class="timeline-details-header">Operations</div>
                                <ul data-bind="foreach: tasks">
                                    <li data-bind="text: operation && operation.name"></li>
                                </ul>
                            </div>
                            -->
                            <div class="timeline-unit icon">
                                <time data-bind="text: time"></time>
                            </div>
                            <div class="w-tooltips-adv pos-top" data-bind="template: { name: 'infoButton-template', data: $data.infoButton.getTemplateViewModel() }"></div>
                        </div>
                        <!-- /ko -->

                        <!-- ko if: type == 'conflict' -->
                        <div class="timeline-item is-conflict">
                            <div class="timeline-unit icon">
                                <span class="time">Conflict</span>
                            </div>
                        </div>
                        <div class="timeline-btn is-conflict">
                            <div class="timeline-marker" data-bind="event: { click: $parent.onClickUpdateRescheduledSelection }">
                                <span class="icon i-task-group"></span>
                                <span class="icon i-arrow-right"></span>
                                <span class="icon i-reschedule"></span>
                                <time data-bind="text: time"></time>
                            </div>
                        </div>
                        <!-- /ko -->

                    </div>

                </div>

            `;
    }
    renderFilterCell(content, extraClass = "", iconName = "") {
        const classes = [
            "list-page-filter-cell",
            extraClass,
            iconName ? "list-page-filter-cell--with-icon" : "",
        ].filter(Boolean).join(" ");
        const icon = iconName
            ? LpIcon({ name: iconName, size: 16, className: "list-page-filter-cell__icon" })
            : "";
        return `<div class="${classes}">${icon}${content}</div>`;
    }
    createAutocompleteFilter(id, placeholder, tagContainerId, tagCaption) {
        const filter = new filterMultipleAutoComplete_template(id, this.getTemplateViewModel(), this.caller);
        filter.setIsVisible(true);
        filter.setPlaceHolderText(placeholder);
        filter.setFilterContainerClass("lib-dropdown");
        filter.setTagContainerId(tagContainerId);
        filter.setTagContainerCaption(tagCaption);
        filter.setMinInputSuggestionLength(3);
        return filter;
    }
    createDropdownFilter(id, label) {
        const filter = new filterDropdown_template(id, this.getTemplateViewModel(), this.caller);
        filter.setLabel(label);
        return filter;
    }
    createGroupSelectorFilter(id, label) {
        const filter = new filterSingleGroupSelector_template(id, this.getTemplateViewModel(), this.caller);
        const vm = filter.getTemplateViewModel?.();
        if (typeof filter.setLabel === 'function') {
            filter.setLabel(label);
        }
        else if (vm && typeof vm.label === 'function') {
            vm.label(label || '');
        }
        return filter;
    }
    createMultiSelectFilter(id, label, tagContainerId, tagCaption) {
        const filter = new multipleSelector_template(id, this.getTemplateViewModel(), this.caller);
        filter.setLabel(label);
        filter.setFilterContainerClass("lib-dropdown");
        filter.setTagContainerId(tagContainerId);
        filter.setTagContainerCaption(tagCaption);
        return filter;
    }
    //
    // implementation of base class [vnTemplate]
    initPartial() {
        this.operationFilter = this.createGroupSelectorFilter("operationFilter", "Operation");
        this.brandFilter = this.createGroupSelectorFilter("brandFilter", "Brand");
        this.pipelineFilter = this.createGroupSelectorFilter("pipelineFilter", "Pipeline");
        this.executerAutocomplete = this.createAutocompleteFilter("executerFilterAutocomplete", "Task executor", "selected-executers", "Selected Task Executors:");
        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);
        this.simpleFilter.setPlaceholder("Search");
        this.updateStatuses = this.createDropdownFilter("updateStatuses", "Bulk action");
        this.updateStatuses.setDisable(true);
        this.autoRefresh = new autoRefresh_template("autoRefresh", this.getTemplateViewModel(), this.caller);
        this.autoRefresh.setRefreshFrequency(5000);
        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType("tasks");
        this.filterTag = this.createAutocompleteFilter("filterTag", "Extra info tag", "selected-tags", "Selected Extra Info Tags:");
        this.statusFilter = this.createMultiSelectFilter("statusFilter", "Status", "selected-task_statuses", "Selected task statuses:");
    }
    setPrimaryTagsFilterItems(items) {
        this.filterTag.setItems(items);
    }
    // implementation of base class [vnTemplate]
    getTemplateName() {
        return "tasksList_template";
    }
    //
    // implementation of base class [vnTemplate]
    getMainElementClasses() {
        return ["w-content"];
    }
    //
    // implementation of base class [vnTemplate]
    activateLoading() {
        this.getTemplateViewModel().isLoading(1);
    }
    //
    // implementation of base class [vnTemplate]
    deactivateLoading() {
        this.getTemplateViewModel().isLoading(0);
    }
    // implementation of base class [vnTemplate]
    buildViewModel() {
        let self = this;
        return {
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateScheduled_DESC"),
            tasks: ko.observableArray([]),
            hasPipelineFilter: ko.observable(false),
            hasTagFilter: ko.observable(false),
            isLoading: ko.observable(0),
            isVisible: ko.observable('is-visible'),
            operationFilter: ko.observable([]),
            statusOptions: ko.observableArray([]),
            statusOptionsSelected: ko.observable(0),
            statusOptionsSelectedText: ko.observable("all"),
            executorFilter: ko.observable([]),
            idUpdateDelete: ko.observable(),
            listMoreInfo: ko.observable(false),
            permissions: ko.observable(this.initPermissions(['tasklist_manage', 'tasklist_reschedule_task'])),
            taskToDelete: ko.observable({ status: { id: 0 } }),
            taskDeleteConfirmationVisible: ko.observable(0),
            taskUpdateConfirmationVisible: ko.observable(0),
            taskToReschedule: ko.observable(null),
            taskToRescheduleTargetTimeHour: ko.observable(null),
            taskToRescheduleTargetTimeMinute: ko.observable(null),
            taskToRescheduleTargetTimeSecond: ko.observable(null),
            taskToRescheduleTargetTime: ko.observable(null),
            taskToRescheduleTargetDate: ko.observable(null),
            taskToRescheduleIsConflicting: ko.observable(false),
            manualTimeRescheduleIsOpen: ko.observable(false),
            timeline: ko.observableArray([]),
            selectAllChecked: ko.observable(false),
            selectedCount: ko.observable(0),
            setAllChecked: function () {
                return self.setAllChecked();
            },
            onClickChecked: function (data) {
                self.onClickChecked(data);
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onChangeFilterAction: function (data, event) {
                self.onChangeFilterAction(data, event);
            },
            onClickDelete: function (data) {
                self.onClickDelete(data);
            },
            onClickDeleteDialogHide: function (data, event) {
                self.onClickDeleteDialogHide();
            },
            onClickDeleteConfirm: function (data, event) {
                self.onClickDeleteConfirm();
            },
            onClickUpdate: function (data) {
                self.onClickUpdate(data);
            },
            onClickUpdateDialogHide: function (data, event) {
                self.onClickUpdateDialogHide();
            },
            onClickUpdateConfirm: function (data, event) {
                self.onClickUpdateConfirm();
            },
            onClickAdd: function () {
                self.onClickAdd();
            },
            onClickRefresh: function () {
                self.onClickRefresh();
            },
            onClickToggleManualTimeRescheduleIsOpen: function () {
                self.onClickToggleManualTimeRescheduleIsOpen();
            },
            onClickReschedule: function (data) {
                self.onClickReschedule(data);
            },
            onClickUpdateRescheduledSelection: function (data) {
                self.onClickUpdateRescheduledSelection(data);
            },
            onChangeSetRescheduleTime: function () {
                self.onChangeSetRescheduleTime();
            },
            onClickCancelReschedule: function () {
                self.onClickCancelReschedule();
            },
            onClickSaveReschedule: function () {
                self.onClickSaveReschedule();
            },
            onStatusOptionsChange: function (data) {
                self.onStatusOptionsChange(data);
            },
            toggleListMoreInfo: function () {
                self.toggleListMoreInfo();
            },
            getBrandLogoSrc: function (brand) {
                return self.getBrandLogoSrc(brand);
            }
        };
    }
    getBrandLogoSrc(brand) {
        const logoMap = {
            CBRF: "CBR",
            WM: "MW",
            XDAF: "XDA",
            FF: "FF-light",
            FFC: "FFC-light",
        };
        const logoFile = logoMap[brand] || brand;
        return `/assets/images/logos/${logoFile}.svg`;
    }
    onChangeFilterAction(data, event) {
        console.log("Lamara Mouffok --- >>>>");
    }
    toggleListMoreInfo() {
        this.getTemplateViewModel().listMoreInfo(!this.getTemplateViewModel().listMoreInfo());
    }
    onClickRefresh() {
        this.caller.getListData();
    }
    //
    // implementation of base class [vnTemplate]
    getViewModelForRequest() {
        const tagFilter = this.getTemplateViewModel().hasTagFilter() ? this.filterTag.getSelectedItems() : [];
        const pipelineFilter = this.getTemplateViewModel().hasPipelineFilter()
            ? this.pipelineFilter.getTemplateViewModel().selectedOption()
            : 0;
        return {
            filters: {
                operationFilter: this.operationFilter.getTemplateViewModel().selectedOption(),
                status: this.statusFilter.getSelectedItems(),
                brandFilter: this.brandFilter.getTemplateViewModel().selectedOption(),
                pipelineFilter,
                executorFilter: this.executerAutocomplete.getSelectedItems(),
                autoRefreshFilter: this.autoRefresh.getTemplateViewModel().toggleAutoRefresh(),
                tags: tagFilter,
            },
            operationFilter: this.operationFilter.getTemplateViewModel().selectedOption(),
            status: this.statusFilter.getSelectedItems(),
            brandFilter: this.brandFilter.getTemplateViewModel().selectedOption(),
            pipelineFilter,
            executorFilter: this.executerAutocomplete.getSelectedItems(),
            autoRefreshFilter: this.autoRefresh.getTemplateViewModel().toggleAutoRefresh(),
            pagination: this.pagination.getTemplateViewModel().pageNumber(),
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            keywords: this.simpleFilter.getTemplateViewModel().filterKeyword(),
            taskToReschedule: this.getTemplateViewModel().taskToReschedule(),
            taskToRescheduleTargetTime: this.getTemplateViewModel().taskToRescheduleTargetTime(),
            taskToRescheduleTargetDate: this.getTemplateViewModel().taskToRescheduleTargetDate(),
            autoRefresh: this.autoRefresh.getTemplateViewModel().toggleAutoRefresh(),
            searchPresetName: this.filterPreset.getTemplateViewModel().searchPresetName(),
            searchPresetType: 'tasks',
        };
    }
    onClickReorder(value, data, event) {
        this.getTemplateViewModel().orderBy(value);
        if (this.getTemplateViewModel().orderByDirection() == "DESC") {
            this.getTemplateViewModel().orderByDirection("ASC");
        }
        else {
            this.getTemplateViewModel().orderByDirection("DESC");
        }
        this.getTemplateViewModel().orderByAndDirection(value + "_" + this.getTemplateViewModel().orderByDirection());
        this.caller.reorderTasks();
    }
    setHasTagFilter(value) {
        this.getTemplateViewModel().hasTagFilter(value);
    }
    setOperationFilterItems(operations) {
        if (!Array.isArray(operations)) {
            return;
        }
        const options = [...operations];
        options.unshift({ "id": 0, "name": "all" });
        this.operationFilter.setOptions(options);
        this.operationFilter.setSelectedOption(0);
    }
    setStatusFilterItems(statuses) {
        if (!Array.isArray(statuses)) {
            return;
        }
        const statusOptions = statuses.map((status) => {
            const variant = getTaskStatusOptionVariant(status?.name ?? status?.id);
            const label = escapeHtml(status?.name ?? status?.id);
            return {
                ...status,
                itemClass: 'task-status-filter-option',
                itemIcon: `<span class="task-status task-status--${variant}">${label}</span>`,
            };
        });
        this.statusFilter.setItems(statusOptions);
    }
    setUpdateStatuses(status) {
        if (!Array.isArray(status)) {
            return;
        }
        this.updateStatuses.setOptions(status);
    }
    setBrandFilterItems(brand) {
        if (!Array.isArray(brand)) {
            return;
        }
        const options = [...brand];
        options.unshift({ "id": 0, "name": "all" });
        this.brandFilter.setOptions(options);
        this.brandFilter.setSelectedOption(0);
    }
    setPipelineFilterItems(pipeline) {
        if (pipeline && pipeline.length) {
            this.getTemplateViewModel().hasPipelineFilter(true);
            const options = [...pipeline];
            options.unshift({ "id": 0, "name": "all" });
            options.push({ "id": null, "name": "Other" });
            this.pipelineFilter.setOptions(options);
            this.pipelineFilter.setSelectedOption(0);
        }
        else {
            this.getTemplateViewModel().hasPipelineFilter(false);
        }
    }
    setIdUpdateDelete(idUpdateDelete) {
        this.getTemplateViewModel().idUpdateDelete(idUpdateDelete);
    }
    setPagination(totalCount) {
        this.pagination.setNumberItemToPaginate(totalCount);
    }
    setPermissions(permissions) {
        this.getTemplateViewModel().permissions(this.normalizePermissions(permissions));
    }
    normalizePermissions(apiPermissions) {
        const normalized = this.initPermissions(['tasklist_manage', 'tasklist_reschedule_task']);
        if (!apiPermissions || typeof apiPermissions !== 'object') {
            return normalized;
        }
        for (const value of Object.values(apiPermissions)) {
            if (!value || typeof value !== 'object') {
                continue;
            }
            const permission = value;
            const flags = this.extractPermissionFlags(permission);
            if (permission.idSection === 33) {
                normalized['tasklist_manage'] = flags;
            }
            else if (permission.idSection === 34) {
                normalized['tasklist_reschedule_task'] = flags;
            }
        }
        if (apiPermissions['tasklist_manage']) {
            normalized['tasklist_manage'] = this.extractPermissionFlags(apiPermissions['tasklist_manage']);
        }
        if (apiPermissions['tasklist_reschedule_task']) {
            normalized['tasklist_reschedule_task'] = this.extractPermissionFlags(apiPermissions['tasklist_reschedule_task']);
        }
        return normalized;
    }
    extractPermissionFlags(permission) {
        return {
            read: !!permission.read,
            write: !!permission.write,
            update: !!permission.update,
            delete: !!permission.delete,
        };
    }
    setResultPage(totalCount, execTime = 0) {
        let resultsInfoToSet = {
            nbr_results: totalCount,
            nbr_pages: Math.ceil(totalCount / this.pagination.getTemplateViewModel().itemPerPage),
            execution_time: execTime
        };
        this.resultsInfo.setResults(resultsInfoToSet);
    }
    resetPageNumber() {
        this.pagination.getTemplateViewModel().pageNumber(1);
    }
    resetOrderParameters() {
        this.getTemplateViewModel().orderBy("id");
        this.getTemplateViewModel().orderByDirection("DESC");
        this.getTemplateViewModel().orderByAndDirection("id_DESC");
    }
    onUpdateError() {
        console.log('onUpdateError');
    }
    /**
     * @param tasks
     */
    setTasks(tasks) {
        this.getTemplateViewModel().selectAllChecked(false);
        const safeTasks = Array.isArray(tasks) ? tasks : [];
        safeTasks.forEach((task) => {
            if (!task) {
                return;
            }
            if (task.status == null) {
                task.status = { "id": null, "name": "Pending" };
            }
            if (task.status.name == null) {
                task.status.name = "Pending";
            }
            if (task.operation == null) {
                task.operation = { name: "" };
            }
            if (task.userInfo == null) {
                task.userInfo = "";
            }
            if (task.type == null) {
                task.type = "";
            }
            if (task.dateUpdated == null || typeof task.dateUpdated !== "object") {
                task.dateUpdated = { date: task.formattedDateUpdated || task.dateUpdated || "" };
            }
            task.checked = false;
            task.extraInfo = (task.extraInfo != null) ? JSON.stringify(task.extraInfo) : "";
            if (task.taskExecuter) {
                task.brand = task.taskExecuter.taskExecuter ? task.taskExecuter.taskExecuter.split("-")[0] : "";
                if (task.taskExecuter.name == null) {
                    task.taskExecuter.name = task.taskExecuter.taskExecuter || "";
                }
            }
            else {
                task.taskExecuter = { name: "", taskExecuter: "", group: null };
                task.brand = "";
            }
        });
        this.getTemplateViewModel().tasks(safeTasks);
        this.setSelectedCount();
    }
    setAllChecked() {
        let selectAllValue = this.getTemplateViewModel().selectAllChecked();
        let tasks = this.getTemplateViewModel().tasks();
        for (var index in tasks) {
            tasks[index].checked = selectAllValue;
        }
        this.getTemplateViewModel().tasks([]);
        this.getTemplateViewModel().tasks(tasks);
        this.setSelectedCount();
        return true;
    }
    setSelectedCount() {
        let selectedCount = 0;
        let tasks = this.getTemplateViewModel().tasks();
        for (var index in tasks) {
            if (tasks[index].checked == true) {
                selectedCount++;
            }
        }
        this.getTemplateViewModel().selectedCount(selectedCount);
        this.updateStatuses.setDisable(selectedCount === 0);
        if (selectedCount > 0) {
            this.autoRefresh.setToggleAutoRefresh(false);
        }
    }
    onClickDelete(task) {
        this.getTemplateViewModel().taskToDelete(task);
        this.getTemplateViewModel().taskDeleteConfirmationVisible(1);
    }
    onClickDeleteDialogHide() {
        this.getTemplateViewModel().taskDeleteConfirmationVisible(0);
    }
    onClickDeleteConfirm() {
        this.getTemplateViewModel().taskDeleteConfirmationVisible(0);
        this.caller.deleteTask(this.getTemplateViewModel().taskToDelete());
    }
    onClickUpdate(task) {
        if (this.updateStatuses.getTemplateViewModel().selectedOption() == this.getTemplateViewModel().idUpdateDelete()) {
            this.getTemplateViewModel().taskUpdateConfirmationVisible(1);
        }
        else {
            this.onClickUpdateConfirm();
        }
        this.disposeTimeLine();
    }
    onClickUpdateDialogHide() {
        this.getTemplateViewModel().taskUpdateConfirmationVisible(0);
    }
    onClickUpdateConfirm() {
        this.getTemplateViewModel().taskUpdateConfirmationVisible(0);
        let tasks = this.getTemplateViewModel().tasks();
        let ids = [];
        for (let index in tasks) {
            if (tasks[index].checked == true) {
                ids.push(tasks[index].id);
            }
        }
        this.caller.updateTask(ids, this.updateStatuses.getTemplateViewModel().selectedOption());
    }
    /**
     * Handles the add task action.
     */
    onClickAdd() {
        this.caller.addTask();
    }
    onClickChecked(data) {
        let tasks = this.getTemplateViewModel().tasks();
        this.getTemplateViewModel().tasks([]);
        this.getTemplateViewModel().tasks(tasks);
        this.setSelectedCount();
        return true;
    }
    onClickToggleManualTimeRescheduleIsOpen() {
        let manualTimeRescheduleIsOpen = this.getTemplateViewModel().manualTimeRescheduleIsOpen();
        if (manualTimeRescheduleIsOpen) {
            this.getTemplateViewModel().manualTimeRescheduleIsOpen(false);
        }
        else {
            this.getTemplateViewModel().manualTimeRescheduleIsOpen(true);
        }
    }
    onClickReschedule(task) {
        this.onClickCancelReschedule();
        this.getTemplateViewModel().taskToReschedule(task);
        this.caller.rescheduleTask(this.getTemplateViewModel().taskToReschedule());
    }
    setTimeline(timeline) {
        this.getTemplateViewModel().taskToRescheduleIsConflicting(false);
        for (var index in timeline) {
            if (timeline[index].type == "conflict") {
                this.getTemplateViewModel().taskToRescheduleIsConflicting(true);
            }
            if (timeline[index].source == true) {
                let taskToRescheduleTargetTime = this.getTemplateViewModel().taskToRescheduleTargetTime();
                if (taskToRescheduleTargetTime == null) {
                    let splitTime = timeline[index].time.split(":");
                    this.getTemplateViewModel().taskToRescheduleTargetTimeHour(splitTime[0]);
                    this.getTemplateViewModel().taskToRescheduleTargetTimeMinute(splitTime[1]);
                    this.getTemplateViewModel().taskToRescheduleTargetTimeSecond(splitTime[2]);
                    this.getTemplateViewModel().taskToRescheduleTargetTime(timeline[index].time);
                }
                let taskToRescheduleTargetDate = this.getTemplateViewModel().taskToRescheduleTargetDate();
                if (taskToRescheduleTargetDate == null) {
                    this.getTemplateViewModel().taskToRescheduleTargetDate(timeline[index].date);
                }
            }
            if (timeline[index].type == "block") {
                timeline[index].infoButton = new infoButton_template("infoButton" + index, this.getTemplateViewModel(), this.caller);
                timeline[index].infoButton.setTitle('Operations');
                let tasks = '';
                for (let task of timeline[index].tasks) {
                    tasks = tasks + '<p>' + task.operation.name + '</p>';
                }
                timeline[index].infoButton.setContent(tasks);
            }
        }
        this.getTemplateViewModel().timeline([]);
        this.getTemplateViewModel().timeline(timeline);
        console.log(this.getTemplateViewModel().taskToRescheduleIsConflicting());
    }
    onClickUpdateRescheduledSelection(slot) {
        let splitTime = slot.time.split(":");
        this.getTemplateViewModel().taskToRescheduleTargetTimeHour(splitTime[0]);
        this.getTemplateViewModel().taskToRescheduleTargetTimeMinute(splitTime[1]);
        this.getTemplateViewModel().taskToRescheduleTargetTimeSecond(splitTime[2]);
        this.getTemplateViewModel().taskToRescheduleTargetTime(slot.time);
        this.getTemplateViewModel().taskToRescheduleTargetDate(slot.date);
        this.caller.rescheduleTask();
    }
    onChangeSetRescheduleTime() {
        let taskToRescheduleTargetTimeHour = ~~this.getTemplateViewModel().taskToRescheduleTargetTimeHour();
        if (taskToRescheduleTargetTimeHour > 23) {
            taskToRescheduleTargetTimeHour = 23;
        }
        if (taskToRescheduleTargetTimeHour < 0) {
            taskToRescheduleTargetTimeHour = 0;
        }
        let taskToRescheduleTargetTimeMinute = ~~this.getTemplateViewModel().taskToRescheduleTargetTimeMinute();
        if (taskToRescheduleTargetTimeMinute > 59) {
            taskToRescheduleTargetTimeMinute = 59;
        }
        if (taskToRescheduleTargetTimeMinute < 0) {
            taskToRescheduleTargetTimeMinute = 0;
        }
        let taskToRescheduleTargetTimeSecond = ~~this.getTemplateViewModel().taskToRescheduleTargetTimeSecond();
        if (taskToRescheduleTargetTimeSecond > 59) {
            taskToRescheduleTargetTimeSecond = 59;
        }
        if (taskToRescheduleTargetTimeSecond < 0) {
            taskToRescheduleTargetTimeSecond = 0;
        }
        let taskToRescheduleTargetTimeHourPadded = this.padInteger(taskToRescheduleTargetTimeHour, 2);
        let taskToRescheduleTargetTimeMinutePadded = this.padInteger(taskToRescheduleTargetTimeMinute, 2);
        let taskToRescheduleTargetTimeSecondPadded = this.padInteger(taskToRescheduleTargetTimeSecond, 2);
        this.getTemplateViewModel().taskToRescheduleTargetTimeHour(taskToRescheduleTargetTimeHourPadded);
        this.getTemplateViewModel().taskToRescheduleTargetTimeMinute(taskToRescheduleTargetTimeMinutePadded);
        this.getTemplateViewModel().taskToRescheduleTargetTimeSecond(taskToRescheduleTargetTimeSecondPadded);
        this.getTemplateViewModel().taskToRescheduleTargetTime(taskToRescheduleTargetTimeHourPadded + ":" + taskToRescheduleTargetTimeMinutePadded + ":" + taskToRescheduleTargetTimeSecondPadded);
        this.caller.rescheduleTask();
    }
    onClickCancelReschedule() {
        this.disposeTimeLine();
    }
    onClickSaveReschedule() {
        this.caller.saveRescheduleTask();
    }
    onStatusOptionsChange(selected) {
        this.getTemplateViewModel().statusOptionsSelectedText(selected.name);
        this.caller.getListData();
    }
    padInteger(number, size) {
        let s = number + "";
        while (s.length < size)
            s = "0" + s;
        return s;
    }
    setSearchableFields(searchableFields) {
        this.simpleFilter.setSearchableFields(searchableFields);
    }
    setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }
    addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }
    setFilterSelectedItems(objFilter, urlParams) {
        if (objFilter instanceof filterSingleGroupSelector_template) {
            const options = [...objFilter.getTemplateViewModel().options()];
            const selectedValue = this.normalizeFilterValue(urlParams);
            const selectedOption = options.find((option) => {
                if (option.id === null || selectedValue === null) {
                    return option.id === selectedValue;
                }
                return option.id == selectedValue;
            });
            if (selectedOption) {
                objFilter.setSelectedOption(selectedOption.id);
                objFilter.setselectedOptionText(selectedOption.name);
            }
        }
        if (objFilter instanceof filterDropdown_template) {
            objFilter.setSelectedOption(urlParams);
        }
        if (objFilter instanceof multipleSelector_template) {
            if (urlParams) {
                const params = urlParams ? urlParams : [];
                let selectedOptionsFromParams = [];
                let selectedIDsFromParams = [];
                for (let param of params) {
                    if (param === "") {
                        param = null;
                    }
                    const selectedOptions = objFilter.getItems().filter(o => o.id == param);
                    if (selectedOptions.length > 0) {
                        const selectedOption = objFilter.getItems().filter(o => o.id == param)[0];
                        selectedOptionsFromParams.push(selectedOption);
                        if (selectedOption) {
                            selectedIDsFromParams.push(selectedOption.id);
                        }
                    }
                }
                objFilter.setSelectedItems(selectedOptionsFromParams);
                objFilter.setTags(selectedIDsFromParams, objFilter.getItems());
            }
        }
        if (objFilter instanceof autoRefresh_template) {
            objFilter.setToggleAutoRefresh(urlParams);
        }
        if (objFilter instanceof filterMultipleAutoComplete_template) {
            objFilter.setItems(urlParams);
        }
    }
    setMultipleAutocompletePresetFilter(autocompleteFilter, items) {
        if (items) {
            const ids = items.map(t => t.id);
            const names = items.map(t => t.name);
            if (ids != null && names != null && ids.length == names.length) {
                let items = [];
                for (let i = 0; i < ids.length; i++) {
                    items.push({ id: ids[i], name: names[i] });
                }
                autocompleteFilter.getTemplateViewModel().selectedItems(items);
                autocompleteFilter.getTemplateViewModel().selectedItemIds(ids);
                autocompleteFilter.getTemplateViewModel().selectedItemNames(names);
                autocompleteFilter.getTemplateViewModel().setTags(ids, items);
            }
            else {
                autocompleteFilter.getTemplateViewModel().selectedItems(null);
                autocompleteFilter.getTemplateViewModel().selectedItemIds(null);
                autocompleteFilter.getTemplateViewModel().selectedItemNames(null);
            }
        }
    }
    setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            this.setFilterSelectedItems(this.brandFilter, urlParams.brandFilter);
            this.setMultipleAutocompletePresetFilter(this.executerAutocomplete, urlParams.executorFilter);
            this.setFilterSelectedItems(this.operationFilter, urlParams.operationFilter);
            if (this.getTemplateViewModel().hasPipelineFilter()) {
                this.setFilterSelectedItems(this.pipelineFilter, urlParams.pipelineFilter);
            }
            this.setFilterSelectedItems(this.statusFilter, urlParams.status);
            this.setFilterSelectedItems(this.autoRefresh, urlParams.autoRefreshFilter);
            if (this.getTemplateViewModel().hasTagFilter() && urlParams.tags) {
                this.setMultipleAutocompletePresetFilter(this.filterTag, urlParams.tags);
            }
            else {
                this.setMultipleAutocompletePresetFilter(this.filterTag, []);
            }
        }
    }
    normalizeFilterValue(value) {
        if (typeof value === 'undefined' || value === '') {
            return 0;
        }
        if (value === 'null') {
            return null;
        }
        return value;
    }
    disposeTimeLine() {
        this.getTemplateViewModel().taskToRescheduleIsConflicting(false);
        this.getTemplateViewModel().taskToReschedule(null);
        this.getTemplateViewModel().taskToRescheduleTargetTime(null);
        this.getTemplateViewModel().taskToRescheduleTargetDate(null);
        this.getTemplateViewModel().timeline([]);
    }
}
